import { useState } from "react";

//lib

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  getProductList,
  setFilterData,
} from "../../../redux/reducer/product.reducer";
import { openFilterModal } from "../../../redux/reducer/modal.reducer";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Button from "../../../components/element/button";
import Container from "../../../components/element/container";
import FilterModal from "../modals/filter.modal";
import Dropdown from "../../../components/element/dropdown";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/element/icon";
import HomeFilteredValues from "./home.filtered.values";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function HomeSearchFilter({
  section = "all",
  showModal = true,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { width } = useWindowDimension();
  const { productList, filterData, topSearch } = useSelector(
    (state) => state.product,
  );
  const { isOpenFilterModal } = useSelector((state) => state.modal);

  const [type, setType] = useState("");
  const [search, setSearch] = useState("");

  const category = filterData.category || "all";
  const categoryData = filterData[category] || {};

  const filterList = [
    {
      label: "Brand Model",
    },
    {
      label: "Price",
    },
    {
      label: "Year",
    },
    {
      label: "Body Type",
    },
  ];

  const currentYear = new Date().getFullYear();
  const defaultYearRange = [2016, currentYear];
  const defaultPriceRange = [100000, 1000000];
  const selectedLocationLabels = categoryData.location || [];
  const selectedShowroomLabels = categoryData.show_room || [];

  const isRangeDifferent = (range = [], defaults = []) =>
    Array.isArray(range) &&
    range.length === 2 &&
    (range[0] !== defaults[0] || range[1] !== defaults[1]);

  const activeFilterMap = {
    "Brand Model":
      (categoryData.brand || []).length > 0 ||
      (categoryData.car_model || []).length > 0,
    Price: isRangeDifferent(categoryData.price, defaultPriceRange),
    Year: isRangeDifferent(categoryData.year, defaultYearRange),
    "Body Type": (categoryData.body_type || []).length > 0,
  };

  const handleOpenFilter = (filterType) => {
    setType(filterType);
    dispatch(openFilterModal());
  };

  const handleSearch = (value = search) => {
    dispatch(
      getProductList({
        ...categoryData,
        search: value,
        start: 0,
        length: 9,
        category: category === "all" ? "" : category,
      }),
    )
      .unwrap()
      .then((res) => {
        const productData = res.data.products || res.data[category] || [];

        dispatch(
          setFilterData({
            ...filterData,
            [category]: {
              ...categoryData,
              data: productData,
              search: value,
              start: 0,
              has_more: res.data.totalFiltered > productData.length,
            },
          }),
        );
      })
      .catch((ex) => {});
  };

  const renderSearchSection = section === "all" || section === "search";
  const renderFilterSection = section === "all" || section === "filter";

  return (
    <Container className={`home-search-filter ${section}`}>
      {renderSearchSection && (
        <Col className="home-search">
          <Row className="_row search flex-nowrap">
            <input
              value={search}
              placeholder={t("search by Model, Make...")}
              className="_input"
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  handleSearch(search);
                }
              }}
            />

            <Icon
              icon="eva:search-outline"
              className="_svg search pointer"
              onClick={() => handleSearch(search)}
            />
          </Row>
          <Row className="_row search-list">
            <Row className="_row top-search">
              <p className="_label top-search-title">{t("Top Search")}</p>
              <Icon icon="fluent-emoji-flat:fire" className="_svg hot" />
            </Row>
            {topSearch.map((search, searchIndex) => {
              const keyword =
                search.search_term ||
                `${search.brand?.name ?? ""}${
                  search.car_model?.name ? ` ${search.car_model?.name}` : ""
                }`;
              return (
                keyword && (
                  <Button
                    key={searchIndex}
                    className="_button search-item"
                    onClick={() => {
                      setSearch(keyword);
                      handleSearch(keyword);
                    }}
                  >
                    {keyword}
                  </Button>
                )
              );
            })}
          </Row>
        </Col>
      )}
      {renderFilterSection && (
        <Col className="home-filter">
          <Col className="w-100">
            <Row className="_row filter-list">
              {filterList.map((filter, filterIndex) => (
                <Button
                  key={filterIndex}
                  className={`_button filter-item ${
                    activeFilterMap[filter.label] ? "active" : ""
                  }`}
                  onClick={() => handleOpenFilter(filter.label)}
                >
                  {t(
                    filter.label === "Body Type"
                      ? "Body"
                      : filter.label === "Brand Model" && width <= 400
                        ? "Brand"
                        : filter.label,
                  )}
                </Button>
              ))}
            </Row>
            <HomeFilteredValues />
          </Col>
          <Row className="_row filter-meta w-100 justify-between items-center">
            <Row
              className={`_button filter-state pointer ${
                selectedLocationLabels.length > 0 ||
                selectedShowroomLabels.length > 0
                  ? "active"
                  : ""
              }`}
              onClick={() => handleOpenFilter("Location")}
            >
              <Icon
                tag="span"
                icon="entypo:location"
                className="_svg state"
                gradient
                gradientStops={
                  selectedLocationLabels.length > 0 ||
                  selectedShowroomLabels.length > 0
                    ? [
                        { offset: "0.3397", color: "#EDCB88" },
                        { offset: "0.9414", color: "#966C2D" },
                      ]
                    : [
                        { offset: "0.3397", color: "#ffffff" },
                        { offset: "0.9414", color: "#ffffff" },
                      ]
                }
                width={13}
                height={13}
              />
              <p>
                {selectedLocationLabels.length > 0
                  ? "Location"
                  : "All Location"}
              </p>
            </Row>
            <p className="_label showing-result">
              {t("Showing")} {categoryData.data?.length || 0} {t("of")}{" "}
              {productList?.category_totals?.[category] ??
                productList?.totalFiltered ??
                0}
            </p>
            <Dropdown
              className={`_dropdown sort-filter ${categoryData.sort ? "active" : ""}`}
              placeholder={
                <>
                  <p>
                    {t(
                      categoryData.sort === "asc"
                        ? "Price (Lowest)"
                        : categoryData.sort === "desc"
                          ? "Price (Highest)"
                          : "Sort",
                    )}
                  </p>
                  <Icon
                    tag="span"
                    icon="mynaui:sort-solid"
                    className="_svg sort"
                    gradient
                    gradientStops={
                      categoryData.sort
                        ? [
                            { offset: "0.3397", color: "#EDCB88" },
                            { offset: "0.9414", color: "#966C2D" },
                          ]
                        : [
                            { offset: "0.3397", color: "#ffffff" },
                            { offset: "0.9414", color: "#ffffff" },
                          ]
                    }
                    width={18}
                    height={18}
                  />
                </>
              }
              options={[
                {
                  label: t("Default"),
                  value: "",
                },
                {
                  label: t("Price (Highest)"),
                  value: "desc",
                },
                {
                  label: t("Price (Lowest)"),
                  value: "asc",
                },
              ]}
              onClick={(value) => {
                dispatch(
                  setFilterData({
                    ...filterData,
                    [category]: {
                      ...categoryData,
                      sort: value || "",
                      start: 0,
                    },
                  }),
                );
              }}
            />
          </Row>
        </Col>
      )}
      {showModal && renderFilterSection && isOpenFilterModal && (
        <FilterModal type={type} />
      )}
    </Container>
  );
}
